import { useChat } from '../contexts/ChatContext'
import { Tip } from '@ofself/shell'

export default function IncomingCallPanel() {
  const { incomingCall, dismissIncomingCall, joinHuddleFromNotification } = useChat()

  if (!incomingCall) return null

  const { channelId, channelName, huddle, startedBy } = incomingCall
  const participants = huddle?.participants || []

  return (
    <div className="incoming-call-panel">
      <div className="incoming-call-header">
        <div className="incoming-call-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
          </svg>
        </div>
        <div className="incoming-call-info">
          <div className="incoming-call-channel">
            {channelName || 'Call'}
          </div>
          <div className="incoming-call-starter">
            {startedBy || 'Someone'} started a call
          </div>
        </div>
      </div>

      {participants.length > 0 && (
        <div className="incoming-call-participants">
          {participants.slice(0, 5).map((p, i) => (
            <Tip key={p.user_id || i} label={p.username}>
              <div className="incoming-call-avatar">
                {(p.username || '?')[0].toUpperCase()}
              </div>
            </Tip>
          ))}
          {participants.length > 5 && (
            <div className="incoming-call-avatar incoming-call-avatar-more">
              +{participants.length - 5}
            </div>
          )}
        </div>
      )}

      <div className="incoming-call-actions">
        <button
          className="incoming-call-btn incoming-call-join"
          onClick={() => joinHuddleFromNotification(channelId)}
        >
          Join
        </button>
        <button
          className="incoming-call-btn incoming-call-dismiss"
          onClick={dismissIncomingCall}
        >
          Dismiss
        </button>
      </div>
    </div>
  )
}
